var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"reset-password-form-container"},[_c('div',{staticClass:"login-form-wrappper"},[_vm._m(0),_c('ResetPasswordForm')],1)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"logo-container"},[_c('span',{staticClass:"logo-wrapper"},[_c('img',{attrs:{"src":require("../../../assets/images/Accura logo design_Web_blue.svg"),"alt":"Accura"}})])])
}]

export { render, staticRenderFns }